module.exports = __webpack_public_path__ + "img/title_sponsor.aba82e54.png";